export const cbmLoadingMessage = 'Loading... This may take up to 30 seconds'

export const orderSubmitMessages = {
  submitOrder: 'Please wait. Attempting to submit order.',
  validateInstall: 'Please wait. Attempting to validate install date and time.',
  waitingConfirmation: 'Please wait. Waiting for order confirmation.',
  abtCreatingHouseKey:
    'Please Wait...Attempting to create your address and house key within the biller. '
}
